import React, {useRef, useState} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonItem,
    IonPage, IonTextarea,
    IonTitle, IonToolbar
} from "@ionic/react";

const ModalPopup = ({dismiss, title, body}: { dismiss: (data?: string | null | undefined, role?: string) => void, title: string, body: {
        description: string;
        bullets: string[]
    } | null | undefined}) => {

    const [note, setNote] = useState<string | null | undefined>(undefined);
    const modal = useRef<HTMLIonModalElement>(null);

    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{title}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                {body &&
                    <div>
                        <p>{body.description}</p>
                        <ul>
                            {body.bullets.map((bullet, index) => {
                                return (
                                    <li key={'bullet_' + index}>{bullet}</li>
                                );
                            })
                            }
                        </ul>
                    </div>
                }
                <p style={{textAlign: 'right'}}>
                    <IonButton onClick={() => dismiss(undefined, 'cancel')}>Close</IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalPopup;